
import { useStore as useVuexStore } from 'vuex';
import { defineStore, storeToRefs } from "pinia";
import { ref } from 'vue';
import { obterTrimestreAtual } from '@/utils/obterTrimestreAtual';

import { carregarParecerMinimo, carregarDisciplinasDaArea, carregarObjetivosArea, carregarCompetencias,carregarSugestoesFetch, salvarPareceres, carregarPareceres } from "@/api/fetchParecer";
import { carregarNotacoes } from "@/api/fetchNotacoes";
import { carregarDesempenhoPorCompetencia } from "@/api/fetchNotas";
import { removeHTMLTags, removeExtraSpaces, replaceHTMLTagsWithWhitespace } from '@/utils/index';




import { calcularParecerObjetivoArea, calcularParecerSugestoes, calcularParecerDificuldadesDestaques } from "@/utils/calcularParecer";
import { result } from 'lodash';
import { useFeedbackStore } from './useFeedbackStore';



export const useCriarParecerParaEstudantesStore = defineStore('criarParecerParaEstudantes', () => {
    const storeFeedback = useFeedbackStore();
    // Dados Base
    const user = ref(null);
    const idDaArea = ref(null);
    const nomeDaArea = ref(null);
    const vuexStore = useVuexStore();
    idDaArea.value = vuexStore.state.userSession.user.areaId;
    nomeDaArea.value = vuexStore.state.userSession.user.areaNome;
    const anoSelecionado = ref("1");
    const trimestresSelecionados = ref([{ label: `${obterTrimestreAtual()}° tri`, value: `${obterTrimestreAtual()}` }]);
    
    const disciplinasDaArea = ref([]);
    const disciplinasSelecionadas = ref([])
    const idDaTurma = ref(null);
    const estudantes = ref([]);
    const anoLetivo = ref()
    const nomesEstudantes = ref([])
    const pareceresMuitoLongos = ref([])


    const desempenhoPorComponente = ref([])
    const desempenhoDosEstudantesPorComponente = ref([]);

    // Conteúdos do parecer
    const parecerMinimo = ref({});
    const objetivosArea = ref({ conteudo: [] });
    const competencias = ref([]);
    const sugestoesMelhoria = ref([]);

    const desempenhoPorCompetencia = ref([]);
    const desempenhoPorCriterio = ref([]);

    const pareceres = ref([]);

    const inconsistencias = ref([]);

    async function carregarDados() {
        vuexStore.dispatch('updateLoading', true);
        parecerMinimo.value = await carregarParecerMinimo(trimestresSelecionados.value[0].value, anoSelecionado.value, idDaArea.value);

        disciplinasDaArea.value = await carregarDisciplinasDaArea(idDaArea.value);
        

        objetivosArea.value.conteudo = await carregarObjetivosArea(trimestresSelecionados.value[0].value, anoSelecionado.value, disciplinasDaArea.value);
        
        competencias.value = await carregarCompetencias(disciplinasDaArea.value, trimestresSelecionados.value[0].value, anoSelecionado.value);

        

        let desempenho = await carregarNotacoes(anoLetivo.value, [trimestresSelecionados.value[0].value], disciplinasDaArea.value.map(item => item.id), estudantes.value);

        desempenhoDosEstudantesPorComponente.value = agruparNotasPorEstudante(desempenho);
     

        let {desempenhoCompetencia, desempenhoCriterio} = await carregarDesempenhoPorCompetencia(estudantes.value, competencias.value.map(competencia => competencia.id))

        if (objetivosArea.value.conteudo.length === 0 || competencias.value.length === 0) {
            alert('Falta objetivos da área ou competências para o parecer poder ser criado');
            vuexStore.dispatch('updateLoading', false);
            return
        }

        desempenhoCompetencia.map(item => {
            item.competencias.map(competencia => {
                let textoCompetencia = competencias.value.find(item => item.id === competencia.id)
                return Object.assign(competencia, { competencia: textoCompetencia.competencia })
            })
        })
        desempenhoPorCompetencia.value = desempenhoCompetencia;
        desempenhoPorCriterio.value = desempenhoCriterio;

        // calcular junto com o por competencia o desempenho por critério


        sugestoesMelhoria.value = await carregarSugestoesFetch(idDaArea.value, trimestresSelecionados.value[0].value, anoSelecionado.value)

        estudantes.value.forEach(estudante => {
            calcularParecer(estudante)
        })

        let pareceresSalvos = await salvarPareceres(pareceres.value);
        pareceres.value = await carregarPareceres(anoLetivo.value, idDaArea.value, trimestresSelecionados.value.map(trimestre => trimestre.value), estudantes.value);

        inconsistencias.value.forEach(inconsistencia => {
            const data = `${inconsistencia.estudante} tem inconsistência em ${inconsistencia.disciplina}. ${inconsistencia.tipo}`;
            storeFeedback.show(false, data, false);
        })
        inconsistencias.value = [];

        pareceresMuitoLongos.value.forEach(parecer => {
            const data = `O estudante ${parecer} tem parecer muito longo`;
            storeFeedback.show(false, data, false);
        })

        pareceresMuitoLongos.value = [];

        vuexStore.dispatch('updateLoading', false);

    }

    
    function calcularParecer(estudante) {
        
        let parecer = '';
        let desempenhoNosComponentes = desempenhoDosEstudantesPorComponente.value.find(item => item.estudante === estudante)
        let desempenhoNasCompetencias = desempenhoPorCompetencia.value.find(item => item.estudante === estudante);
        let desempenhoNosCriterios = desempenhoPorCriterio.value.find(item => item.estudante == estudante)

        let parte1 = calcularParecerObjetivoArea(parecerMinimo.value, objetivosArea.value.conteudo, desempenhoNosComponentes.desempenho);
        let parte2 = '';
        let parte3 = '';
        

        if (desempenhoNasCompetencias !== undefined) {
            let resultado = calcularParecerDificuldadesDestaques(desempenhoNasCompetencias.competencias, desempenhoNosComponentes.desempenho, disciplinasDaArea.value, true);
            
            parte2 = resultado.parecer;
            resultado.inconsistencias.forEach(inconsistencia => {
                let disciplinaDaInconsistencia = disciplinasDaArea.value.filter(item => item.id === inconsistencia.disciplina)
                let nomeEstudante = nomesEstudantes.value.find(item => item.id === estudante)
                inconsistencias.value.push({disciplina: disciplinaDaInconsistencia[0].nome, tipo: inconsistencia.tipo, estudante: nomeEstudante.nome});
            })

        }else{
            let nomeEstudante = nomesEstudantes.value.find(item => item.id === estudante)
            alert(`Faltaram dados do estudante ${nomeEstudante.nome} para criar um parecer apropriado. Revise ele manualmente depois.`)
        }

        
        if(desempenhoNosCriterios !== undefined) {
            const idsDesejados = [1, 2, 5, 6];
            const criteriosFiltrados = desempenhoNosCriterios.criterios.filter(criterio => idsDesejados.includes(criterio.id));

            if(anoSelecionado.value === '3' && trimestresSelecionados.value[0].value === '3'){
                parte3 = "";  
            }else{
                parte3 = calcularParecerSugestoes(criteriosFiltrados, sugestoesMelhoria.value, nomeDaArea.value, desempenhoNosComponentes.desempenho); 
            }

            
        }
        
        parte1 = removeHTMLTags(parte1);
        parte1 = parte1.replaceAll('\n', '');
        parte2 = removeHTMLTags(parte2);
        parte3 = removeHTMLTags(parte3);
        parecer = `${parte1}\n\n${parte2 ? `${parte2}\n\n` : ""}${parte3}`;


        // calcular número de caracteres do parecer
        const tamanhoParecer = parecer.length;
        if(tamanhoParecer >= 4000){
            const nomeEstudante = nomesEstudantes.value.find(item => item.id === estudante).nome
            pareceresMuitoLongos.value.push(nomeEstudante)
        }
        

        //parecer = removeExtraSpaces(parecer);
        //parecer = removeHTMLTags(parecer);
      

         pareceres.value.push({trimestre: trimestresSelecionados.value[0].value, anoLetivo: anoLetivo.value, estudante: estudante, parecer: parecer, area: idDaArea.value});
    }


    function agruparNotasPorEstudante(notas) {
        return notas.reduce((acc, nota) => {
            // Encontra o objeto do estudante no acumulador ou inicializa um novo
            let estudante = acc.find(e => e.estudante === nota.estudante);
            if (!estudante) {
                estudante = {
                    estudante: nota.estudante,
                    desempenho: []
                };
                acc.push(estudante);
            }
            // Verifica se a disciplina já existe no desempenho do estudante
            let desempenho = estudante.desempenho.find(d => d.disciplina === nota.disciplina);
            if (!desempenho) {
                // Se não existir, adiciona novo desempenho
                estudante.desempenho.push({
                    disciplina: nota.disciplina,
                    notacao: nota.notacao
                });
            } else {
                // Se já existir, atualiza a nota (opcional, dependendo do requisito)
                desempenho.notacao = nota.notacao;
            }
            return acc;
        }, []);
    }


    return { anoSelecionado, trimestresSelecionados, idDaTurma, idDaArea, disciplinasDaArea, disciplinasSelecionadas, anoLetivo, estudantes, objetivosArea, desempenhoPorComponente, parecerMinimo, competencias, sugestoesMelhoria, desempenhoPorCompetencia, pareceres, nomesEstudantes, pareceresMuitoLongos, carregarDados }
})